import {createSlice} from "@reduxjs/toolkit";
const initialState={
   auditResults:[],
   sodResponse:[]
  }
  export const sosSodSlice = createSlice({
    name: "sosSodData",
    initialState: {
      load: false,
      page: "default",
      prevPage: "default",
      pos: { x: window.innerWidth - 325, y: 100 },
      openContext: true,
      ...initialState
    },
    reducers: {
    setAuditResultData:(state,action)=>{
        state.auditResults=action.payload;
    },
    toggleAnalysisOptions(state, action) {
      console.log("toggle")
      const { type, value } = action.payload;
      state["analysisOptions"][type]["selected"] = value;
    },
    setLoading(state, action) {
      state.load = action.payload
    },
    changePage(state, action) {
      console.log("change page")
      state.page = action.payload
    },
    setPrevPage(state, action) {
      // if a page is clicked twice, it won't update prev page
      if (state.page !== action.payload) {
        state.prevPage = action.payload
      }
    },
    setPos(state, action) {
      state.pos = action.payload
    },
    setopenContext(state, action) {
      state.openContext = action.payload
    },
    setSodResponse(state,action){
      state.sodResponse=action.payload
    }
    }
  });
// export const {setAuditResultData}= sosSodSlice.actions;
// export default sosSodSlice.reducer;
